<div class="ui-grid-cell-contents flex-valign">
  <a class="file-link" href="javascript:void(0)" data-test="dms-grid-trash-bin-name-template-link">
    <div class="flex-valign">
      @if (!folder()) {
        <em
          class="icon-iris fa-3x file-preview dms-icon-color"
          [ngClass]="fileIcon()"
          [style.font-size]="previewSize + 'px'"
        ></em>
      }

      @if (showLock()) {
        <em class="fas fa-lock lock-icon"></em>
      }

      @if (folder()) {
        @if (!customIconClass()) {
          <iris-folder-svg
            class="folder-preview"
            [folder]="folder()"
            width="30"
            height="30"
          ></iris-folder-svg>
        } @else {
          <em class="flag-icon" [class]="customIconClass()"></em>
        }
      }

      <div class="data-name"
        [matTooltip]="'label.dms.OpenPreview' | translate"
        matTooltipPosition="after"
        [matTooltipDisabled]="!!folder()"
        [style.padding-left.px]="customIconClass() ? 54 : 0">
        {{ displayName() }}
      </div>
    </div>
  </a>
</div>
